import { FormType, ReportJSON } from '@aloft/toolkit-shared';

import { generateTkv2AdjustmentsRptiNodes } from '../generateTkv2AdjustmentsRptiNodes.ts';
import { generateTkv2UADAnnotationRptiNodes } from '../generateTkv2UADAnnotationRptiNodes.ts';
import {
  SFREP_FNMA_1004_ADDITIONAL_COMPS_FORM_CODE,
  SFREP_FNMA_2055_ADDITIONAL_COMPS_FORM_CODE,
} from './consts.ts';

const create1004LikeAdditionalCompsFormNode = (
  doc: XMLDocument,
  compSequence: string[],
  comps: ReportJSON['comps'],
  formID: string,
  meta?: ReportJSON['meta'],
): HTMLElement => {
  const fnma1004AdditionalComps = doc.createElement('Form');
  fnma1004AdditionalComps.setAttribute('Id', formID);

  const reportFields = doc.createElement('Fields');
  fnma1004AdditionalComps.append(reportFields);

  compSequence.forEach((compId, index) => {
    const comp = comps[compId];

    if (comp) {
      reportFields.append(
        ...generateTkv2UADAnnotationRptiNodes(doc, {
          property: comp,
          isComp: true,
          meta,
          compIndex: index,
        }),
      );
    }
  });

  // Add Adjustments each comp
  compSequence.forEach((compId, index) => {
    const comp = comps?.[compId];

    if (comp) {
      reportFields.append(
        ...generateTkv2AdjustmentsRptiNodes(doc, comp, index, FormType.fnma1004, meta),
      );
    }
  });

  fnma1004AdditionalComps.appendChild(reportFields);

  return fnma1004AdditionalComps;
};

export const create1004AdditionalCompsFormNode = (
  doc: XMLDocument,
  compSequence: string[],
  comps: ReportJSON['comps'],
  meta: ReportJSON['meta'],
) =>
  create1004LikeAdditionalCompsFormNode(
    doc,
    compSequence,
    comps,
    SFREP_FNMA_1004_ADDITIONAL_COMPS_FORM_CODE,
    meta,
  );

export const create2055AdditionalCompsFormNode = (
  doc: XMLDocument,
  compSequence: string[],
  comps: ReportJSON['comps'],
  meta: ReportJSON['meta'],
) =>
  create1004LikeAdditionalCompsFormNode(
    doc,
    compSequence,
    comps,
    SFREP_FNMA_2055_ADDITIONAL_COMPS_FORM_CODE,
    meta,
  );
